export enum TtFeatureFlagsEnvironment {
  PRODUCTION = 'production',
  LOCAL = 'local',
  TESTING = 'testing',
  ACCEPTANCE = 'acceptance',
}
